<template>
  <div class="field">
    <label v-if="label" class="flex flex-col sm:flex-row">
      {{ label }}
      <span v-if="helpText" class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
        {{ helpText }}
      </span>
    </label>

    <div class="relative">
      <label
        :class="['input-image', inputClass, { 'border-theme-6': hasError }, { 'mt-2': label }]"
        :style="`background-image: url(${image});`"
      >
        <input
          ref="fileUpload"
          class="hidden"
          type="file"
          name="image"
          :accept="acceptFiles"
          @change="onFileChange"
          :disabled="disabled"
        />
      </label>
      <div
        v-if="image"
        @click="onShow"
        class="w-10 h-10 cursor-pointer flex items-center justify-center absolute text-white bg-theme-6 right-0 bottom-0"
      >
        <zoomInIcon class="w-4 h-4" />
      </div>
    </div>
  </div>
</template>

<script>
import baseInputMixin from '@/mixins/baseInputMixin';
import { CUSTOMER_UPLOAD_IMAGE } from '@/store/actions/customer';
import { isNil } from 'lodash';

export default {
  mixins: [baseInputMixin],

  props: {
    value: String,
    acceptFiles: {
      type: String,
      default: 'image/*',
    },
    imageType: String,
    customerId: Number,
  },

  data() {
    return {
      image: this.value,
    };
  },

  methods: {
    async onFileChange(e) {
      const file = e.target.files[0];

      if (file) {
        const payload = {
          id: this.customerId,
          data: {
            type: this.imageType,
            file,
          },
        };

        await this.$store.dispatch(CUSTOMER_UPLOAD_IMAGE, payload);
        this.image = URL.createObjectURL(file);
      }
    },
    onChange(value) {
      this.$emit('change', value);
      if (isNil(value)) {
        this.image = '';
        const input = this.$refs.fileUpload;
        input.type = 'text';
        input.type = 'file';
      }
    },
    onShow() {
      window.open(this.image, '_blank');
    },
  },
};
</script>
